import { AvatarSkeleton } from "@circleco/compass/components/AvatarSkeleton";
import { Skeleton } from "@circleco/compass/components/Skeleton";

export const MemberCardWithConnectionSkeleton = () => (
  <li
    className="bg-primary outline-primary relative inline-flex h-[274px] flex-col items-center justify-between overflow-hidden rounded-xl px-3 pb-4 pt-3 outline outline-1 outline-offset-[-1px]"
    data-testid="member-card-skeleton"
  >
    <div className="flex w-full flex-col items-center justify-start gap-4 rounded-md py-4">
      {/* Matches the `size="2xl"` avatar the loaded card renders. */}
      <AvatarSkeleton size="2xl" />
      <div className="flex w-full flex-col items-center justify-start gap-2.5">
        <div className="flex w-full flex-col items-center justify-start gap-1">
          <Skeleton className="h-3.5 w-16" shape="pill" />
          <Skeleton className="h-2.5 w-1/2" shape="pill" />
        </div>
        <div className="flex w-full items-center justify-center gap-1 px-2">
          <Skeleton className="h-2 w-7" shape="pill" />
        </div>
      </div>
    </div>
    <div className="inline-flex w-full items-start justify-start gap-2 px-1">
      <Skeleton className="h-9 w-full rounded-full" shape="pill" />
    </div>
  </li>
);
